module.exports = "<p>\n  Du har ikke tilgang til denne portalen.\n</p>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/noentry/noentry.component.html
// module id = ./src/app/noentry/noentry.component.html
// module chunks = main